import React, { FC, useEffect, useRef } from 'react';
import Picture from '../../../@shared/picture';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import Icon from '../../../@shared/icon';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TNewsItemsData } from '../../types/newsFiles.types';
import { iconSize } from '../../../../constants/icon.constants';
import { googleClickCtaEvent } from '../../../../utils/analytics';

const NewsFilesDownloadCard: FC<TNewsItemsData> = (props: TNewsItemsData) => {
  const { fileName, fileSize, thumbnailLink, fileLink, active, componentNumber } = props;
  const linkWrapperRef = useRef<HTMLDivElement>(null);
  const a2aKitRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (a2aKitRef.current && (e.target === a2aKitRef.current || a2aKitRef.current.contains(e.target as Node))) {
        googleClickCtaEvent('News Files', 'Share', fileName.value, componentNumber);
      }
    };
    linkWrapperRef?.current?.addEventListener('click', handleClick, true);

    return () => {
      linkWrapperRef?.current?.removeEventListener('click', handleClick, true);
    };
  }, [fileName.value, componentNumber, linkWrapperRef, a2aKitRef]);

  return (
    <>
      {active && (
        <div className="download_files_card">
          <Picture
            editorialImageProps={{
              desktopImage: thumbnailLink?.value?.href,
              desktopTransformation: 'Size500',
              cssClassPictureEl: 'download_files_card__picture-css--fixed-aspect-ratio',
            }}
          />
          <div className="download_files_card__content">
            <Text field={fileName} tag="h2" className={'download_files_card__title'} />
            <Text field={fileSize} tag="span" className={'download_files_card__file-size'} />
          </div>
          <div className="download_files_card__link-wrapper" ref={linkWrapperRef}>
            <div className={'download_files_card__link'}>
              <div className="download_files_card__link--label a2a_kit a2a_kit_size_32 a2a_default_style" ref={a2aKitRef}>
                <a className="a2a_dd download_files_card__add-to-any" data-a2a-url={fileLink?.value?.href}>
                  <span role="button" className="download_files_card__link-text">
                    <DictionaryTerm keyword="cnhi-share" />
                  </span>
                  <Icon iconName="social-sharing-share" color="primary" size={iconSize.dsk} />
                </a>
              </div>
            </div>
            <RoutableNotEditableLink
              href={fileLink?.value?.href}
              target="_blank"
              className={'download_files_card__link download_files_card__link--download'}
              onClick={() => googleClickCtaEvent('News Files', 'Download', fileName.value, componentNumber)}
            >
              <span className="download_files_card__link--label">
                <DictionaryTerm keyword="cnhi-download" />
              </span>
              <Icon iconName="action-download" color="primary" extraClassName="brochure_card__link__icon" size={iconSize.dsk} />
            </RoutableNotEditableLink>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsFilesDownloadCard;
